import './App.css';
import Homepage from './components/Homepage'; // Import the Homepage component

function App() {
  return (
    <div className="App">
      <Homepage /> {/* Render the Homepage component */}
    </div>
  );
}

export default App;
